export const dayNames = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
const time = s => String(s || '').slice(0,5);
export const periodIncludes = (p,id) => !(p.periodServiceList || []).length || p.periodServiceList.some(s=>Number(s.serviceId)===Number(id));
export function periodSummary(period, groups) {
    const available = groups.filter(g=>g.service_ids.some(id=>periodIncludes(period,id)));
    const partial = available.some(g=>!g.service_ids.every(id=>periodIncludes(period,id)));
    return {count:available.length,restricted:available.length<groups.length || partial,
        text:`${available.length} service${available.length===1?'':'s'} available${partial?' · some variants only':''}`};
}
export function workingRanges(day) {
    return (day?.periodList || []).map(p=>({startTime:time(p.startTime),endTime:time(p.endTime)}));
}
export function groupSchedule(employee, group) {
    const result={};
    for(const day of employee.weekDayList || []) {
        const ranges=(day.periodList || []).filter(p=>group.service_ids.some(id=>periodIncludes(p,id))).map(p=>({startTime:time(p.startTime),endTime:time(p.endTime)}));
        if(ranges.length)result[Number(day.dayIndex)]=ranges;
    }
    return result;
}
export function scheduleLabel(schedule) {
    return Object.keys(schedule).map(Number).sort((a,b)=>a-b).map(d=>`${dayNames[d-1].slice(0,3)} ${schedule[d].map(r=>`${r.startTime}–${r.endTime}`).join(', ')}`).join(' · ') || 'Not offered on weekly days';
}
